import { createFeatureSelector, createSelector } from '@ngrx/store';
import { InsightsJobsState, TrackedJobEntities } from '.';

export const featureSelector = createFeatureSelector<InsightsJobsState>('insights-jobs');

const getTrackedJobEntityState = createSelector(
  featureSelector,
  s => s.trackedJobs
);

const TrackedJobSelectors = TrackedJobEntities.getSelectors<InsightsJobsState>(getTrackedJobEntityState);

export const getTrackedJobs = createSelector(
  TrackedJobSelectors.selectAll,
  (trackedJobs) => trackedJobs
);

export const getTrackedJobsById = createSelector(
  TrackedJobSelectors.selectEntities,
  (trackedJobs) => trackedJobs
);

export const getTrackedJob = (jobid: any) => createSelector(
  TrackedJobSelectors.selectEntities,
  (trackedJobs) => trackedJobs[jobid]
);

export const getTrackedJobState = (jobId: any) => createSelector(
  TrackedJobSelectors.selectEntities,
  (trackedJobs) => trackedJobs[jobId]
);

export const isJobTrackingDone = (jobId: any) => createSelector(
  TrackedJobSelectors.selectEntities,
  (trackedJobs) => !trackedJobs[jobId]
);
